import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
//import Footer from "components/footers/FiveColumnWithInputForm.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm text-gray-800`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
    }
  }
`;
export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Text>
            <h2>Jak działają e-cenówki w inteligentnym magazynie?</h2>
            <h3>1. Automatyczna synchronizacja danych</h3>
            <p>
            Etykiety ESL są bezpośrednio zintegrowane z systemem magazynowym (WMS lub ERP). Każda zmiana w bazie danych – przesunięcie towaru, zmiana lokalizacji, aktualizacja ilości – natychmiast pojawia się na odpowiedniej etykiecie.
            </p>
            <h3>2. Geolokalizacja i system „Pick-to-Light”</h3>
            <p>
            Wszystkie e-cenówki wyposażone są w diody LED, które mogą:
            <ul>
              <li>- wskazywać pracownikowi właściwą półkę lub karton,</li>
              <li>- sygnalizować kolejność kompletacji,</li>
              <li>- minimalizować pomyłki podczas pakowania.</li>
            </ul>
            To ogromne wsparcie przy obsłudze zamówień e-commerce, gdzie liczy się szybkość i precyzja.
            </p>
            <h3>3. Dynamiczne etykietowanie lokalizacji</h3>
            <p>
            W magazynach o zmiennych konfiguracjach (np. sezonowych) e-cenówki pozwalają:
            <ul>
              <li>- natychmiast zmieniać nazwy sektorów i regałów,</li>
              <li>- aktualizować oznaczenia bez drukowania papierowych etykiet,</li>
              <li>- wprowadzać reorganizacje bez chaosu.</li>
            </ul>
            </p>
            <h3>4. Sygnalizacja stanów i alertów</h3>
            <p>
            Elektroniczne etykiety mogą informować o:
            <ul>
              <li>- niskim stanie magazynowym,</li>
              <li>- konieczności zatowarowania,</li>
              <li>- kontroli dat ważności,</li>
              <li>- wyświetalć alert dla kierownika (np. uszkodzona paleta),</li>
              <li>- wyświetlać status kompletacji: „gotowe”, „w toku”, „oczekuje”.</li>
            </ul>
            Dzięki temu magazyn działa płynniej i szybciej.
            </p>
            <p>
            Dzięki e-cenówkom magazyn staje się szybszy, bardziej precyzyjny i gotowy na wyzwania logistyki przyszłości.
            </p>
          </Text>
      <MainFeature1
        subheading={<Subheading>Wdrożenia</Subheading>}
        heading="WKRÓTCE"
        description = ""
        // buttonRounded={false}
        primaryButtonText="Obejrzyj film >>"
        primaryButtonUrl = ""
        imageSrc="./magazyny_org.jpg"
        textOnLeft={false}
      />
      {/* <MainFeature1
        // subheading={<Subheading>KROK 2 - wykonanie aplikacji</Subheading>}
        heading=""
        description = ""
        // buttonRounded={false}
        primaryButtonText=""
        primaryButtonUrl = ""
        imageSrc=""
      /> */}
      {/* <MainFeature1
        subheading={<Subheading>KROK 3 - utrzymanie i serwis</Subheading>}
        heading="Jesteśmy tutaj aby pomagać."
        description ="Dokładamy wszelkich starań, aby nasze aplikacje działały bez zarzutu. Jeśli potrzebujesz zaktualizwoać swoje dane lub potrzebujesz porady dotyczącej Twojej eWizytówki skontaktuj się z naszym ekspertem."
        // buttonRounded={false}
        primaryButtonText="Serwis 24/7"
        primaryButtonUrl = "/serwis"
        imageSrc = "./serwis.jpg"
        textOnLeft={false}
      /> */}
      {/* <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading="We follow these."
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
        ]}
        linkText=""
      />
      <TeamCardGrid 
        subheading={<Subheading>Our Team</Subheading>}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
};
